import axios from "../utils/axios";

/**
 * List all departments
 * @param {Object} params - Query parameters (page, per_page, search, is_active)
 * @returns {Promise} Departments list
 */
export const getDepartments = async (params) => {
    try {
        const { data } = await axios.get('/admin/departments', { params });
        return data;
    } catch (error) {
        console.error("🚀 ~ getDepartments ~ error:", error);
        throw error;
    }
};

/**
 * Get a department by ID
 * @param {number|string} id - Department ID
 * @returns {Promise} Department data
 */
export const getDepartmentById = async (id) => {
    try {
        const { data } = await axios.get(`/admin/departments/${id}`);
        return data;
    } catch (error) {
        console.error("🚀 ~ getDepartmentById ~ error:", error);
        throw error;
    }
};

/**
 * Create a new department
 * @param {Object} departmentData - Department data
 * @returns {Promise} Created department
 */
export const createDepartment = async (departmentData) => {
    try {
        const { data } = await axios.post('/admin/departments', departmentData);
        return data;
    } catch (error) {
        console.error("🚀 ~ createDepartment ~ error:", error);
        throw error;
    }
};

/**
 * Update a department
 * @param {number|string} id - Department ID
 * @param {Object} departmentData - Updated department data
 * @returns {Promise} Updated department
 */
export const updateDepartment = async (id, departmentData) => {
    try {
        const { data } = await axios.put(`/admin/departments/${id}`, departmentData);
        return data;
    } catch (error) {
        console.error("🚀 ~ updateDepartment ~ error:", error);
        throw error;
    }
};

/**
 * Delete a department
 * @param {number|string} id - Department ID
 * @returns {Promise} Result of deletion
 */
export const deleteDepartment = async (id) => {
    try {
        const { data } = await axios.delete(`/admin/departments/${id}`);
        return data;
    } catch (error) {
        console.error("🚀 ~ deleteDepartment ~ error:", error);
        throw error;
    }
};
